import { render, staticRenderFns } from "./NewsListingItem.vue?vue&type=template&id=29771ba6&scoped=true&"
import script from "./NewsListingItem.vue?vue&type=script&lang=js&"
export * from "./NewsListingItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsListingItem.vue?vue&type=style&index=0&id=29771ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29771ba6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/NewsListingItem.vue
// module id = 18
// module chunks = 0